import { useLazyQuery } from '@apollo/client';
import { CHECK_PICKUP_ROUTE_ZIPCODE_CONFLICT, PickupRouteZipcodeConflictResponse, PickupRouteZipcodeConflictVariables } from '../graphql/queries/checkPickupRouteZipcodeConflict';

export const usePickupRouteZipcodeConflictCheck = () => {
  const [checkConflict, { loading, error }] = useLazyQuery<
    PickupRouteZipcodeConflictResponse,
    PickupRouteZipcodeConflictVariables
  >(CHECK_PICKUP_ROUTE_ZIPCODE_CONFLICT);

  const checkZipcodeConflict = async (
    warehouseId: number,
    zipcodes: string[],
    excludeRouteId?: number,
    routeName?: string
  ) => {
    try {
      const { data } = await checkConflict({
        variables: {
          warehouseId,
          zipcodes,
          excludeRouteId,
          routeName
        }
      });

      return {
        hasConflict: data?.checkPickupRouteZipcodeConflict.hasConflict || false,
        conflictingRoutes: data?.checkPickupRouteZipcodeConflict.conflictingRoutes || [],
        conflictingZipcodes: data?.checkPickupRouteZipcodeConflict.conflictingZipcodes || [],
        conflictDetails: data?.checkPickupRouteZipcodeConflict.conflictDetails || [],
        hasNameConflict: data?.checkPickupRouteZipcodeConflict.hasNameConflict || false,
        conflictingRouteNames: data?.checkPickupRouteZipcodeConflict.conflictingRouteNames || [],
        invalidWarehouseZipcodes: data?.checkPickupRouteZipcodeConflict.invalidWarehouseZipcodes || [],
        hasWarehouseValidationConflict: data?.checkPickupRouteZipcodeConflict.hasWarehouseValidationConflict || false,
        error: null
      };
    } catch (err) {
      return {
        hasConflict: false,
        conflictingRoutes: [],
        conflictingZipcodes: [],
        conflictDetails: [],
        hasNameConflict: false,
        conflictingRouteNames: [],
        invalidWarehouseZipcodes: [],
        hasWarehouseValidationConflict: false,
        error: err
      };
    }
  };

  return {
    checkZipcodeConflict,
    loading,
    error
  };
};
